import { IReduxState } from "../reducers"

export default function emailSendingStateSelector(state: IReduxState) {
	return state.emailStore.emailSent
}
